/* Live room mockups: redraw the room gallery images for the selected Type / Size / Frame.
   Same maths as mockup2.py: landscape scenes (1536x1024, 3.8 px/cm) and portrait scenes (1024x1536, 5.5 px/cm),
   print hung ~18cm above whatever furniture is below, wall extended upward for big prints,
   art cover-cropped to the print's aspect ratio, camera distance follows print size.

   This section (and its data/script tags) can be rendered MORE THAN ONCE on the same page - once
   for the main product page, and again inside every quick-add modal a shopper has opened on a
   collection/gallery-wall page. Everything below is scoped to THIS script's own <product-info>
   ancestor (found via document.currentScript, which reliably points at this exact <script> tag
   even when several copies of this file have each run their own IIFE) so that two open modals for
   different products never read/write each other's data or DOM. */
(function () {
  // This script tag can be re-inserted (and re-run) more than once on the same page - once for the
  // main product page, and again inside every quick-add modal a shopper opens. Dawn's quick-add.js
  // re-injects it via a freshly created <script> element (to make it execute at all, since plain
  // innerHTML never runs scripts), which means it runs as if async - document.currentScript is not
  // reliable here. Instead, claim the first not-yet-claimed data element in document order; since
  // this IIFE runs synchronously to completion before any other copy of this same file can start,
  // the claim always lands on the right one for whichever copy is executing right now.
  var dataEl = null;
  var candidates = document.querySelectorAll('.sent-live-mockup-data:not([data-sent-claimed])');
  if (candidates.length) { dataEl = candidates[0]; dataEl.setAttribute('data-sent-claimed', '1'); }
  if (!dataEl) return;
  var root = dataEl.closest('product-info') || document;
  // Inside a quick-add modal Dawn forces every media slide except the first to
  // `display: none !important` (assets/quick-add.css) - it's designed to show one compact static
  // image only. Our room-preview slides live at position 2+, so any attempt to activate one there
  // (see the old `showRoom` thumbnail-click below) makes that now-active slide the ONLY slide, and
  // it's exactly the one Dawn hides - blank white image. There's no useful room-preview to show in
  // this cramped a UI anyway, so just leave Dawn's own static image alone in this context.
  if (root.closest('quick-add-modal')) return;
  var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var S_LAND = 3.8, S_PORT = 7.0, PAD = 420, OUT_W = 1080, OUT_H = 1350, BORDER_FRAC = 0.09;
  var FRAMES = { 'Oak': '#cfb28d', 'Black': '#1a1a19', 'Dark Oak': '#4d3228', 'White': '#ece6de' };   // measured from Prodigi's frame-profile images
  var art = null, scenes = {}, grays = {}, exts = {}, border = null;

  function load(src) {
    return new Promise(function (res, rej) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); }; im.onerror = rej; im.src = src;
    });
  }
  function gray(i) {
    if (grays[i]) return grays[i];
    var w = scenes[i].naturalWidth, h = scenes[i].naturalHeight;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d'); x.drawImage(scenes[i], 0, 0);
    var d = x.getImageData(0, 0, w, h).data, g = new Uint8Array(w * h);
    for (var p = 0, q = 0; p < d.length; p += 4, q++) g[q] = (d[p] * 299 + d[p + 1] * 587 + d[p + 2] * 114) / 1000;
    return (grays[i] = { g: g, w: w, h: h });
  }
  function freeBottom(G, x0, x1) {
    var g = G.g, W = G.w, H = G.h;
    x0 = Math.max(0, x0); x1 = Math.min(W, x1);
    var n = x1 - x0, mean = new Float64Array(H), std = new Float64Array(H);
    for (var r = 0; r < H; r++) {
      var s = 0, s2 = 0, o = r * W + x0;
      for (var k = 0; k < n; k++) { var v = g[o + k]; s += v; s2 += v * v; }
      mean[r] = s / n; std[r] = Math.sqrt(Math.max(0, s2 / n - mean[r] * mean[r]));
    }
    for (var y = 300; y < H - 40; y++) if (std[y] > 9 || Math.abs(mean[y + 1] - mean[y]) > 4) return y;
    return Math.round(H * 0.68);
  }
  function borderPad(img, color) {          // same inward crop-and-pad maths as the print-file
    var w = img.naturalWidth, h = img.naturalHeight;   // generator (generate_bordered_prints_full.py):
    var m = Math.min(w, h) * BORDER_FRAC;              // canvas stays the art's own size/aspect, so the
    var innerW = w - 2 * m, innerH = h - 2 * m;         // margin painted here is never cropped uneven later
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d');
    x.fillStyle = color; x.fillRect(0, 0, w, h);
    var ar = w / h, tr = innerW / innerH, sx = 0, sy = 0, sW = w, sH = h;
    if (ar > tr) { sW = h * tr; sx = (w - sW) / 2; } else { sH = w / tr; sy = (h - sH) / 2; }
    x.drawImage(img, sx, sy, sW, sH, m, m, innerW, innerH);
    return c.toDataURL('image/jpeg', 0.92);
  }
  function ext(i) {          // scene with extra wall continued upward
    if (exts[i]) return exts[i];
    var w = scenes[i].naturalWidth, h = scenes[i].naturalHeight;
    var c = document.createElement('canvas'); c.width = w; c.height = h + PAD; var x = c.getContext('2d');
    try { x.filter = 'blur(18px)'; } catch (e) {}
    x.drawImage(scenes[i], 0, 0, w, 6, 0, -20, w, PAD + 20);
    x.filter = 'none'; x.drawImage(scenes[i], 0, PAD);
    return (exts[i] = c);
  }
  function render(i, wcm, hcm, frame, isCanvas, closeup, useBorder) {
    var sw = scenes[i].naturalWidth, sh = scenes[i].naturalHeight, portrait = sh > sw, S = portrait ? S_PORT : S_LAND;
    var c = document.createElement('canvas'); c.width = OUT_W; c.height = OUT_H;
    var x = c.getContext('2d');
    var framed = !!FRAMES[frame], ow = wcm, oh = hcm, aw_cm = wcm, ah_cm = hcm, gap = 0;
    if (framed && isCanvas) { ow = wcm + 3.4; oh = hcm + 3.4; gap = 0.5; }       // float frame (Prodigi spec: 12mm face, 5mm gap)
    else if (framed) { ow = wcm + 3; oh = hcm + 3; aw_cm = wcm - 1; ah_cm = hcm - 1; }   // Prodigi classic: 20mm face, 5mm rebate
    var pw = Math.round(ow * S), ph = Math.round(oh * S), aw0 = Math.round(aw_cm * S), ah0 = Math.round(ah_cm * S), gp = Math.round(gap * S);
    var ax = Math.round((pw - aw0) / 2), ay = Math.round((ph - ah0) / 2);
    var x0 = Math.floor(sw / 2) - Math.floor(pw / 2), free = freeBottom(gray(i), x0 - 15, x0 + pw + 15);
    var cy = Math.min(free - (portrait ? 35 : 70) - Math.floor(ph / 2), Math.floor(0.36 * sh)), y0 = Math.max(100 - PAD, cy - Math.floor(ph / 2)) + PAD;
    var floorE = Math.floor(0.9 * sh) + PAD, fe = free + PAD, acx = x0 + pw / 2, maxW = portrait ? sw : 760, cw, chh, ct;
    if (closeup) {          // centred on the print, stops above the furniture
      cw = Math.max(portrait ? 0.42 * sw : 480, Math.min(maxW, pw * (portrait ? 2.0 : 3.2)));
      chh = cw * 1.25;
      ct = Math.min(y0 + ph / 2 - chh / 2, fe - 15 - chh);
    } else {                // room shot: from just above the print down to the floor, furniture shown whole
      chh = floorE - (y0 - 60);
      cw = Math.min(Math.max(chh * 0.8, portrait ? 0.5 * sw : 560), maxW);
      chh = cw * 1.25;
      ct = Math.min(floorE - chh, y0 - 40);
      if (ct + chh < floorE - 5) ct = Math.min(y0 + ph / 2 - chh / 2, fe - 15 - chh);   // print too big to fit whole furniture: wall only, never half a chair
    }
    var cl = Math.min(Math.max(0, acx - cw / 2), sw - cw);
    ct = Math.max(ct, Math.min(PAD, y0 - 40));
    ct = Math.min(Math.max(0, ct), sh + PAD - chh);
    var KK = OUT_W / cw;
    x.drawImage(ext(i), cl, ct, cw, chh, 0, 0, OUT_W, OUT_H);
    var X = (x0 - cl) * KK, Y = (y0 - ct) * KK, W = pw * KK, H = ph * KK;
    x.save();
    x.shadowColor = 'rgba(40,30,20,.5)'; x.shadowBlur = (isCanvas ? 12 : 8) * KK; x.shadowOffsetX = 3 * KK; x.shadowOffsetY = 6 * KK;
    x.fillStyle = FRAMES[frame] || '#fff'; x.fillRect(X, Y, W, H);
    x.restore();
    if (framed && isCanvas) { x.fillStyle = '#1e1a16'; x.fillRect(X + (ax - gp) * KK, Y + (ay - gp) * KK, (aw0 + 2 * gp) * KK, (ah0 + 2 * gp) * KK); }
    else if (framed) { x.fillStyle = 'rgba(0,0,0,.28)'; x.fillRect(X + ax * KK - 1, Y + ay * KK - 1, aw0 * KK + 2, ah0 * KK + 2); }
    var AX = X + ax * KK, AY = Y + ay * KK, AW = aw0 * KK, AH = ah0 * KK, bx = AX, by = AY, bw = AW, bh = AH;
    if (useBorder) {          // draw the mat directly at this size's exact box, not from a pre-baked file - a
      var bm = Math.min(AW, AH) * BORDER_FRAC;   // static file's margin only looks even at ONE aspect ratio, and
      x.fillStyle = useBorder; x.fillRect(AX, AY, AW, AH);   // would come out lopsided once cover-cropped to another
      bx = AX + bm; by = AY + bm; bw = AW - 2 * bm; bh = AH - 2 * bm;
    }
    var ar = art.naturalWidth / art.naturalHeight, tr = bw / bh;
    var sx = 0, sy = 0, sW = art.naturalWidth, sH = art.naturalHeight;
    if (ar > tr) { sW = sH * tr; sx = (art.naturalWidth - sW) / 2; } else { sH = sW / tr; sy = (art.naturalHeight - sH) / 2; }
    x.drawImage(art, sx, sy, sW, sH, bx, by, bw, bh);
    if (isCanvas && !framed) { x.fillStyle = 'rgba(0,0,0,.22)'; x.fillRect(X + W - 4 * KK, Y + 3 * KK, 4 * KK, H - 3 * KK); }
    return c.toDataURL('image/jpeg', 0.88);
  }
  function selection() {
    var vs = root.querySelector('variant-selects'); if (!vs) return null;
    var t = vs.querySelector('.sent-type-picker input:checked'), sz = vs.querySelector('.sent-size-picker select'), f = vs.querySelector('.sent-frame-picker input:checked');
    var m = sz && sz.value.match(/^(\d+) x (\d+) cm$/); if (!m || !t) return null;
    return { canvas: t.value === 'Canvas', w: +m[1], h: +m[2], frame: f ? f.value.replace(/^(Classic|Solid Wood) /, '') : 'No frame' };
  }
  function setImg(el, url) {
    if (!el) return;
    el.removeAttribute('srcset'); el.removeAttribute('sizes'); el.src = url; el.style.opacity = 1;
  }
  var busy = false;
  function update(showRoom) {
    var s = selection(); if (!s || !art || busy) return;
    busy = true;
    var slides = root.querySelectorAll('.product__media-list > li'), thumbs = root.querySelectorAll('.thumbnail-list__item');
    // gallery order: [0] card, [1] static lifestyle shot, [2..] live rooms
    function put(pos, url) {
      var sl = slides[pos]; if (sl) [].forEach.call(sl.querySelectorAll('img'), function (im) { setImg(im, url); });
      var th = thumbs[pos]; if (th) setImg(th.querySelector('img'), url);
    }
    try {
      D.scenes.slice(1).forEach(function (idx, k) { put(2 + k, render(idx, s.w, s.h, s.frame, s.canvas, false, border)); });   // scene 0 is the close-up, so the rooms use the other scenes (no duplicates)
    } finally {
      busy = false;
    }
    if (showRoom) { var b = thumbs[2] && thumbs[2].querySelector('button'); if (b) b.click(); }
  }
  root.addEventListener('change', function (e) {
    var vs = e.target.closest && e.target.closest('variant-selects'); if (!vs || !root.contains(vs)) return;
    var isFS = e.target.matches('.sent-frame-picker input, .sent-size-picker select, .sent-type-picker input');
    setTimeout(function () { update(isFS); }, 60);
    setTimeout(function () { update(false); }, 1200);
  });
  // Lets the gallery-border colour swatches (rendered separately in buy-buttons.liquid) make the
  // room-mockup previews reflect the bordered print too, not just the flat card image. Drawn fresh
  // into each render() at that size's own exact box (see BORDER_FRAC above) rather than swapped in
  // from a pre-baked bordered file - a static file's margin is only even at the one aspect ratio it
  // was baked for, and comes out lopsided once cover-cropped to any other size.
  root.sentSetGalleryBorder = function (colorOrNull) {
    border = colorOrNull || null;
    update(false);
  };
  // Same border, applied to the flat card image - reuses the already-loaded `art` image instead of
  // fetching anything new. Returns a Promise (art may not have finished loading the first time a
  // shopper clicks a swatch) that resolves to a data URL, or null if art never loads.
  root.sentBorderedCardUrl = function (color) {
    return new Promise(function (resolve) {
      var tries = 0;
      (function tryNow() {
        if (art) return resolve(borderPad(art, color));
        if (++tries > 30) return resolve(null);
        setTimeout(tryNow, 150);
      })();
    });
  };
  Promise.all([load(D.art)].concat(D.scenes.map(function (i) { return load(D.sceneUrls[i]).then(function (im) { scenes[i] = im; }); })))
    .then(function (r) { art = r[0]; update(false); setTimeout(function () { update(false); }, 900); })
    .catch(function () { /* keep the static fallback images */ });
})();
